import { isRichText, richTextToPlain, sanitizeRichText } from "./richText";

export async function copyRichText(value = "") {
  const content = value || "";
  const html = isRichText(content) ? sanitizeRichText(content) : null;
  const plain = html === null ? content : richTextToPlain(html).trimEnd();

  if (html !== null && navigator.clipboard.write && typeof ClipboardItem !== "undefined") {
    try {
      await navigator.clipboard.write([new ClipboardItem({
        "text/html": new Blob([html], { type: "text/html" }),
        "text/plain": new Blob([plain], { type: "text/plain" }),
      })]);
      return;
    } catch {
      // Some browsers allow text copying but reject HTML clipboard writes.
    }
  }
  await navigator.clipboard.writeText(plain);
}
